import React, { Component } from "react"
import { Formik, Field, Form } from "formik"
import submitData from "helpers/submitData"
import settings from "settings"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "actions"
import { bindActionCreators } from "redux"
import _ from "lodash"

class Fees extends Component {
	constructor(props) {
		super(props)

		let fields = {}
		_.forEach(props.data?.addl?.feesTable, (v) => {
			if (v.check) {
				fields[v.fee] = v.check
			}
		})
		this.state = {
			data: {
				address: "",
			},
			fields,
			image_type: null,
		}
	}

	submitClasses = (f) => {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f,
		})

		return submitClasses
	}

	buildFields = (f) => {
		let ret = []
		_.forEach(settings.localFields.feesTable.presets, (v) => {
			if (!v.builderEntry || !v.properties.includes(this.props.data.property)) return
			ret.push(
				<li className={`form__listItem`} key={v.name}>
					<label htmlFor={v.name}>{v.name} - Check #</label>
					{f.errors[v.name] && f.touched[v.name] && <div className="form__message">{f.errors[v.name]}</div>}
					<Field name={v.name} type="text" className="form__input" />
				</li>
			)
		})
		return ret
	}

	formLayout = (f) => {
		return (
			<div>
				{/* console.log(f) */}
				<Form>
					<ul className="modalForm__list">{this.buildFields(f)}</ul>
					<input type="submit" value="Submit" className={this.submitClasses(f.isValid)} />
				</Form>
			</div>
		)
	}

	render() {
		return (
			<div className="modal">
				<h3>Fees: {this.props.data.address}</h3>
				<Formik
					initialValues={this.state.fields}
					enableReinitialize
					onSubmit={(values) => {
						values.id = this.props.data.id
						values.action = "builderInputFees"
						values.feesTable = settings.localFields.feesTable
						//delete values.images
						submitData("mainIngest", values)
							.then((data) => {
								this.props.notify(data, this.props.name)
							})
							.catch((e) => {
								this.props.notify(e, this.props.name)
							})
					}}
					render={(f) => this.formLayout(f)}
				/>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		trafficSources: state.trafficSources,
		payload: state.payload,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getPayload,
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(Fees)
